import { AnimatePresence } from "framer-motion";
import { useHive } from "@/store/useHive";
import { Window } from "./Window";

export function WindowManager() {
  const windows = useHive((s) => s.windows);
  return (
    <div className="pointer-events-none absolute inset-0">
      <AnimatePresence>
        {windows
          .filter((w) => !w.minimized)
          .map((w) => (
            <div key={w.id} className="pointer-events-auto">
              <Window win={w} />
            </div>
          ))}
      </AnimatePresence>
    </div>
  );
}
